import React from 'react'

function NoPage() {
  return (
    <div className="NoPage">
      <h1>Error 404. Unknown URL</h1>
    </div>
  )
}

export default NoPage